import paperSrc from './assets/paper.svg';
import rockSrc from './assets/rock.svg';
import scissorsSrc from './assets/scissors.svg';

export enum Option {
  Rock = 0,
  Paper = 1,
  Scissors = 2,
}

export const ResourceSrc = {
  [Option.Rock]: rockSrc,
  [Option.Paper]: paperSrc,
  [Option.Scissors]: scissorsSrc,
};

export enum AnimationSequence {
  Stop = 0,
  Start = 1,
  ShowResult = 2,
}

export enum MatchResult {
  Win = 0,
  Draw = 1,
  Lose = 2,
}
